import React from 'react'
import { ReactComponent as Circle } from '@images/Survey/circles.svg'
import './styles.scss'

function CirclesBackground({ children }) {
  return (
    <div className='circles-decorator'>
      <Circle />
      {children}
    </div>
  )
}

export default CirclesBackground
